var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$.card }, [
    _c("div", { class: _vm.$.header }, [
      _vm.config.includes("header_upper")
        ? _c(
            "div",
            { class: _vm.$.upper },
            [
              _c("skeleton-item", {
                style: { height: "12px", width: "192px" },
                attrs: { type: "bar" },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { class: _vm.$.lower }, [
        _c(
          "div",
          { class: _vm.$.left },
          [_c("skeleton-item", { attrs: { type: "square", size: "sm" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: _vm.$.right },
          [
            _vm.config.includes("header_lower_right_upper")
              ? _c("skeleton-item", {
                  class: _vm.$.item,
                  style: { height: "12px", width: "192px" },
                  attrs: { type: "bar" },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("skeleton-item", {
              class: _vm.$.item,
              style: { height: "12px" },
              attrs: { type: "bar", width: "big" },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$.main },
      [
        _c("skeleton-item", {
          style: { height: "20px", width: "72px" },
          attrs: { type: "bar" },
        }),
        _vm._v(" "),
        _c("skeleton-item", { attrs: { type: "circle", size: "sm" } }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { class: _vm.$.footer },
      [
        _c("skeleton-item", {
          style: { height: "12px", width: "100px" },
          attrs: { type: "bar" },
        }),
        _vm._v(" "),
        _vm.config.includes("footer_right")
          ? _c("skeleton-item", { attrs: { type: "square", size: "bg" } })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }